module.exports = require('./helpers/bundle-url').getBundleURL('ezjVb') + "logo.c51670a8.svg";